<template>
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card gallery-root">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ title }}</p>
                <button class="delete" aria-label="close" @click="onClose"></button>
            </header>
            <section class="modal-card-body content">
                <div class="buttons">
                    <a
                        class="button is-small is-rounded"
                        @click="onPrevImageClick"
                        :disabled="disablePrev"
                    >
                        <span class="icon is-small">
                            <i class="fas fa-chevron-circle-left"></i>
                        </span>
                    </a>
                    <a
                        class="button is-small is-rounded"
                        @click="onNextImageClick"
                        :disabled="disableNext"
                    >
                        <span class="icon is-small">
                            <i class="fas fa-chevron-circle-right"></i>
                        </span>
                    </a>
                </div>
                <div class="canvas">
                    <img class="large-image" :src="selectedUrl" />
                </div>
                <hr />
                <div class="thumbnails">
                    <div
                        v-for="(image, index) in images"
                        class="thumbnail"
                        :key="image"
                        @click="imageSelected(image, index)"
                    >
                        <img class="small-image" :src="image" />
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ImageGallery',
    props: {
        images: Array, // String
        title: String,
        onClose: Function,
    },
    data: () => ({
        selected: null,
    }),
    computed: {
        disableNext() {
            return this.selectedIndex === this.images.length - 1
        },
        disablePrev() {
            return this.selectedIndex === 0
        },
        selectedUrl() {
            if (this.selected === null) {
                return this.images[0]
            }
            return this.selected
        },
        selectedIndex() {
            if (this.selected === null) {
                return 0
            }
            return this.images.indexOf(this.selected)
        },
    },
    methods: {
        imageSelected(image) {
            this.selected = image
        },
        onNextImageClick() {
            this.selected = this.images[this.selectedIndex + 1]
        },
        onPrevImageClick() {
            this.selected = this.images[this.selectedIndex - 1]
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../sass/variables';

.gallery-root {
    height: 90vh;
}

.content {
    display: flex;
    flex-direction: column;
}

.canvas {
    flex: 1;
}

.thumbnails {
    display: flex;
    width: 100%;
    height: 150px;
    overflow-x: scroll;
}

.thumbnail {
    cursor: pointer;
    margin: 3px;
}

.large-image {
    height: 50vh;
    width: 100%;
}

.small-image {
    height: 128px;
    width: 128px;
}

.buttons {
    display: flex;
    margin-bottom: 15px;
    width: 100%;
    justify-content: center;
}
</style>
